import debounce from 'lodash/debounce'

// One drawer motion animates several properties, so collapse the burst into a
// single announcement. 300ms spans the longest drawer transition.
const ANNOUNCE_WINDOW_MS = 300

// Every drawer transition must announce exactly one start/end pair: consumers
// react per transition, and a missed pair stops them silently.
export default (drawer: HTMLElement): (() => void) => {
  const emitAnimationStart = debounce(
    () => window.eventHub.$emit('drawer:animation-start'),
    ANNOUNCE_WINDOW_MS,
    { leading: true, trailing: false }
  )

  const emitAnimationEnd = debounce(
    () => window.eventHub.$emit('drawer:animation-end'),
    ANNOUNCE_WINDOW_MS,
    { leading: true, trailing: false }
  )

  // Transitions on descendants bubble; only the drawer's own motion counts.
  const onTransitionStart = (e: Event): void => {
    if (e.target === drawer) emitAnimationStart()
  }

  const onTransitionEnd = (e: Event): void => {
    if (e.target === drawer) emitAnimationEnd()
  }

  drawer.addEventListener('transitionstart', onTransitionStart)
  drawer.addEventListener('transitionend', onTransitionEnd)

  return () => {
    emitAnimationStart.cancel()
    emitAnimationEnd.cancel()
    drawer.removeEventListener('transitionstart', onTransitionStart)
    drawer.removeEventListener('transitionend', onTransitionEnd)
  }
}
